export const SetInventory = {
    noFormat: '설정 가능한 포맷이 존재하지 않습니다.',
    warnIsModified: '설정 중인 내용이 저장되지 않았습니다. 계속 진행하시겠습니까?',
    save: {
        success: '작성하신 내용이 반영되었습니다',
        error: {
            fail: '작성하신 내용이 반영되지 못했습니다\n다시 시도해주세요.',
        },
    },
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신시켜주세요.',
        }
    }
}